const TEACHER_SECTION_IDS = new Set(["usage", "supporting", "quick-check", "tip"]);

export function isTeacherOnlyExplainSection(section) {
  return TEACHER_SECTION_IDS.has(section.id);
}

export function splitExplainDifferentlySections(sections = []) {
  const handoutSections = [];
  const teacherSections = [];

  for (const section of sections) {
    if (isTeacherOnlyExplainSection(section)) {
      teacherSections.push(section);
    } else {
      handoutSections.push(section);
    }
  }

  return { handoutSections, teacherSections };
}
